var FormItem = require("../FormItem");
var BFormItem = require("../form/BFormItem");
var ExtendForm = require("../form/ExtendForm");
var BForm = require("../form/BForm");
var Wecom = require("../wecom/Wecom");
var Tree = require("../Tree");
var Language = require("../Language");
var QForm = require("../QForm"); //qualifyName->生成表单
var Avatar = require("../Avatar");
var HeadTitle = require("../HeadTitle");
var DropMenu = require("../DropMenu");
var RecordItem = require("../RecordItem");
var SingleForm = require("../SingleForm");
var UserCenterHeader = require("../UserCenterHeader");
var UserSwitch = require("../login/UserSwitch");
var Feishu = require("../feishu/Feishu");
var DDLogin = require("../ddLogin/DDLogin");

var Wx = require("../weixin/Wx");

module.exports = {
  getComponent: function () {
    BForm.register();
    BFormItem.register();
    ExtendForm.register();
    QForm.register();
    Tree.register();
    FormItem.register();
    Avatar.register();
    DropMenu.register();
    HeadTitle.register();
    RecordItem.register();
    SingleForm.register();
    UserCenterHeader.register();
    Language.register();
    Wecom.register();
    Wx.register();
    Feishu.register();
    DDLogin.register();
    UserSwitch.register();
  },
};



//////////////////
// WEBPACK FOOTER
// ./src/template/common/component.js
// module id = 34
// module chunks = 0